module.exports = __webpack_public_path__ + "static/media/alfred-avatar.f8e65696.jpg";